import { Text } from "@mantine/core";

export const SeoOpeningTagline = () => (
  <>
    <Text span c="black" fw="bold">
      fs-checklist-studio
    </Text>{" "}
    makes it easy to build realistic flight simulator checklists directly in your browser.
  </>
);
